import { getShouldEnforcePermanentJobV2 } from '~/services/posthog/FeatureFlagUtils';
import { CancellationFeedback } from './CancellationFeedback';
import CancellationFeedbackLegacy from '../CancellationFeedbackLegacy';

export const CancellationFeedbackManager = () => {
  if (getShouldEnforcePermanentJobV2()) {
    return <CancellationFeedback />;
  }

  return <CancellationFeedbackLegacy />;
};
